import {createTheme, ThemeOptions} from '@mui/material';
import {hapStyles} from './hap.styles';

const infinityStyles: ThemeOptions = {
	name: 'infinity',
	colors: hapStyles.colors,
	palette: {
		other: {
			planColor: '#212121',
		},
	},
};

const infinityTheme = createTheme(hapStyles, infinityStyles);

export {infinityStyles, infinityTheme};
